import { createRouter } from "@tanstack/react-router";

import type { AuthCtx } from "~/contexts/auth_query";

import { routeTree } from "./routeTree";

export const router = createRouter({
  routeTree,
  context: undefined as unknown as AuthCtx,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
    context: AuthCtx;
  }
}
